module.exports = __webpack_public_path__ + "static/media/4.af0c4e94.jpg";